<template>
    <div class="text-center">
        <v-progress-circular
            indeterminate
            :size="160"
            :width="10"
        ></v-progress-circular>
    </div>
</template>
